import { render } from "./patchMa.vue?vue&type=template&id=2f668184&scoped=true"
import script from "./patchMa.vue?vue&type=script&lang=js"
export * from "./patchMa.vue?vue&type=script&lang=js"

import "./patchMa.vue?vue&type=style&index=0&id=2f668184&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f668184"]])

export default __exports__